var CHANNEL = "web";
var VERSION = "0";
export { CHANNEL, VERSION };
//# sourceMappingURL=constants.js.map